import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { API_URL, fmtUGX } from './feesUtils';

export const FeesDashboardTab = ({ school, year, term, refreshKey }) => {
  const [kpis, setKpis] = useState(null);
  const [perf, setPerf] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/fees/dashboard`, { params: { academic_year: year, term, school } })
      .then((r) => setKpis(r.data)).catch(() => {});
    axios.get(`${API_URL}/api/fees/class-performance`, { params: { academic_year: year, term } })
      .then((r) => setPerf(r.data)).catch(() => {});
  }, [school, year, term, refreshKey]);

  if (!kpis) return <p className="text-muted-foreground text-sm py-6">Loading…</p>;
  const K = [
    ['Total Expected', fmtUGX(kpis.total_expected), 'text-blue-600'],
    ['Total Collected', fmtUGX(kpis.total_collected), 'text-green-600'],
    ['Total Outstanding', fmtUGX(kpis.total_outstanding), 'text-red-600'],
    ['Collection Rate', `${kpis.collection_rate}%`, 'text-primary'],
    ['Paid in Full', kpis.students_paid_in_full, 'text-emerald-600'],
    ['With Balances', kpis.students_outstanding, 'text-amber-600'],
    ['Total Arrears', fmtUGX(kpis.total_arrears), 'text-orange-600'],
  ];
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3" data-testid="fees-kpis">
        {K.map(([l, v, c]) => (
          <Card key={l}><CardContent className="p-3">
            <p className="text-xs text-muted-foreground">{l}</p>
            <p className={`text-base font-heading font-bold ${c}`}>{v}</p>
          </CardContent></Card>
        ))}
      </div>

      {perf && (
        <Card>
          <CardHeader className="pb-2"><CardTitle className="font-heading text-base">Class Collection Performance — All Schools</CardTitle></CardHeader>
          <CardContent className="p-0 overflow-x-auto">
            <Table>
              <TableHeader><TableRow>
                <TableHead>School</TableHead><TableHead>Class</TableHead><TableHead>Students</TableHead>
                <TableHead className="text-right">Expected</TableHead><TableHead className="text-right">Collected</TableHead>
                <TableHead className="text-right">Outstanding</TableHead><TableHead className="w-44">Collection %</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {perf.classes.filter((c) => c.students > 0 || c.expected_income > 0).map((c) => (
                  <TableRow key={`${c.school}-${c.class_name}`}>
                    <TableCell className="text-xs text-muted-foreground">{c.school === 'suubi_primary' ? 'Primary' : 'Secondary'}</TableCell>
                    <TableCell className="font-medium">{c.class_name}</TableCell>
                    <TableCell>{c.students}</TableCell>
                    <TableCell className="text-right">{fmtUGX(c.expected_income)}</TableCell>
                    <TableCell className="text-right text-green-600">{fmtUGX(c.collected)}</TableCell>
                    <TableCell className="text-right text-red-600">{fmtUGX(c.outstanding)}</TableCell>
                    <TableCell><div className="flex items-center gap-2">
                      <Progress value={Math.min(c.collection_pct, 100)} className="h-2 flex-1" />
                      <span className="text-xs w-11">{c.collection_pct}%</span>
                    </div></TableCell>
                  </TableRow>
                ))}
                {Object.values(perf.school_totals).map((t) => (
                  <TableRow key={t.label} className="bg-muted/40 font-medium">
                    <TableCell colSpan={2}>{t.label}</TableCell>
                    <TableCell>{t.students}</TableCell>
                    <TableCell className="text-right">{fmtUGX(t.expected_income)}</TableCell>
                    <TableCell className="text-right">{fmtUGX(t.collected)}</TableCell>
                    <TableCell className="text-right">{fmtUGX(t.outstanding)}</TableCell>
                    <TableCell className="text-xs">{t.collection_pct}%</TableCell>
                  </TableRow>
                ))}
                <TableRow className="bg-primary/10 font-bold">
                  <TableCell colSpan={2}>ALL SUUBI SCHOOLS</TableCell>
                  <TableCell>{perf.grand_total.students}</TableCell>
                  <TableCell className="text-right">{fmtUGX(perf.grand_total.expected_income)}</TableCell>
                  <TableCell className="text-right">{fmtUGX(perf.grand_total.collected)}</TableCell>
                  <TableCell className="text-right">{fmtUGX(perf.grand_total.outstanding)}</TableCell>
                  <TableCell className="text-xs">{perf.grand_total.collection_pct}%</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
